// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> pillar-properties-avenue -> the-maverick
// Generated: 2026-11-05T04:20:19.041Z
// Counts: 3 design, 32 content, 26 slot group, 3 collection binding, 10 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design.block:privacy-consent.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design.block:privacy-consent.color.text": {
    "cssVariable": "--vibe-color-text",
    "overrideType": "VALUE",
    "value": "#ffffff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio, 1, and 2 Bedroom Apartments in Burien, WA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Maverick, where modern living meets luxury in the heart of Burien! Choose from spacious studio, one-bedroom, or two-bedroom floor plans. Enjoy top-notch amenities like a yoga studio, movie theater, and outdoor grill area. Explore our interactive community map to find your perfect home today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "Your New Home Awaits",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfollow.instagram_embed": {
    "overrideType": "VALUE",
    "customValue": "instagram-oembed",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdc-094e-7772-b991-fa856e914d78.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from a wide variety of <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.themaverickburien.com/floor-plans\">studio, one and two bedroom floor plans</a> with stunning mountain views. The spacious homes at The Maverick feature quartz countertops, oversized walk-in closets, and in-home washer and dryers. Our dedication to creating a truly extraordinary living experience is unsurpassed with a private screening room, resident lounge, private courtyard, and a spa-inspired fitness center. Check out the amenities and features offered at The Maverick below.</p><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover your perfect home at The Maverick in Burien! Our stylish apartment floor plans include cozy studio or spacious one-bedroom and two-bedroom options designed for your comfort. Have questions? Contact our leasing team today to learn more about our vibrant community and available apartment homes. Your ideal living space awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover your ideal living space at The Maverick in Burien! Explore our diverse floor plans, including cozy studios, spacious one-bedroom, and two-bedroom apartments. Each layout is designed to suit your lifestyle. Browse our available apartment homes today and find your perfect floor plan at The Maverick!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover your dream home at The Maverick in Burien! Choose from stylish studio, one-bedroom, or two-bedroom apartments with stunning mountain views. Enjoy endless amenities, including a yoga studio, movie theater, and outdoor BBQ area. Picture yourself living here and experience luxury, comfort, and community—schedule your visit today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover your ideal home at The Maverick in Burien, where we offer stunning studio, one-bedroom, and two-bedroom floor plans. Explore our vibrant neighborhood filled with local favorites and nearby attractions. See what's around our community and embrace the lifestyle you deserve!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Close to everything - our beautiful, oversized modern apartments and townhome-style lofts in Burien, Washington, feature large studio, one-, and two-bedroom floor plans, all within walking distance of downtown Burien.</p><p><br></p><p>Gorgeous views of Mt. Rainier are part of the package that includes quartz countertops, plank flooring, spacious walk-in closets, a kitchen pantry, in-home washer and dryers, plus tons of indoor and outdoor amenity spaces.</p><p><br></p><p>We are located one block from the Transit Center, a short distance from Seattle-Tacoma International Airport, and less than 20 minutes south of Seattle for a quick and easy commute.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span>Experience luxury living at The Maverick in Burien. Schedule a tour today to explore our vibrant community, modern amenities, and spacious apartments. Discover your new home!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore The Maverick in Burien, where comfort meets style! Choose from our thoughtfully designed studio, one-bedroom, or two-bedroom apartments. Don’t miss the chance to see your future home—take a virtual tour today and discover all we have to offer! Your ideal living space awaits at The Maverick!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cde-29cc-709d-981a-12a5b07b7daf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "ctasection.card4_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cdd-63df-7212-92ec-5f51ee5bed19.webp"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cdd-63df-7212-92ec-5f51ee5bed19.webp"
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cdd-8041-740f-bd16-02e2e4bb09fa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with chaise lounges and outdoor seating, overlooking a courtyard and apartment buildings."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cde-72dc-7738-bb04-268fc920a399.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop patio with fire pit and seating."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      3,
      6
    ],
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": 12,
    "hiddenIds": [
      "ec_30ae4b09753aa3a5231e3807",
      "ec_2389dd0b0b61390afb8b65bf",
      "ec_3f8a26f5e10ae00e44bf8838"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      10,
      6,
      12
    ],
    "ordering": null,
    "customItems": null
  },
  "reviewscallout.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "privacy-consent",
      "blockId": "privacy-consent",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 8
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 12
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
